var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-failure" },
    [
      _c(
        "van-dialog",
        {
          attrs: { showConfirmButton: false, closeOnClickOverlay: "true" },
          on: { close: _vm.close },
          model: {
            value: _vm.showDia,
            callback: function ($$v) {
              _vm.showDia = $$v
            },
            expression: "showDia",
          },
        },
        [
          _c("div", { staticClass: "dialog" }, [
            _vm.con
              ? _c("div", { staticClass: "con" }, [_vm._v(_vm._s(_vm.con))])
              : _vm._e(),
            _c("div", { staticClass: "btn", on: { click: _vm.close } }, [
              _vm._v(_vm._s(_vm.$t("lang.gotit"))),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }